import React, { useState, useEffect } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import lightLogo from "../../../img/logo-light.png";
import { ReactComponent as GoogleIcon } from "../../../img/google-icon.svg";
import { sendErrorNotification } from "../../universal/notifications/notifications";
import { ToastContainer } from "react-toastify";
import { auth } from "../../../networking/firebase";
import { useDispatch, useSelector } from "react-redux";
import {
  performRegularLogin,
  performGoogleLogin,
  resetGoogleLogin,
  resetRegularLogin,
} from "../../../redux/actions/authentication";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";
import { Label } from "../../library/label";
import { Input } from "../../library/input";

const Index = (props) => {
  const dispatch = useDispatch();
  const user = auth.currentUser && auth.currentUser.uid;

  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [_, setLoading] = useState(false);

  const regularLoginStatus = useSelector(
    (state) => state.authentication.regularLoginStatus
  );
  const regularLoginError = useSelector(
    (state) => state.authentication.regularLoginError
  );
  const regularLoginLoading = useSelector(
    (state) => state.authentication.regularLoginLoading
  );

  const googleLoginStatus = useSelector(
    (state) => state.authentication.googleLoginStatus
  );
  const googleLoginError = useSelector(
    (state) => state.authentication.googleLoginError
  );
  const googleLoginLoading = useSelector(
    (state) => state.authentication.googleLoginLoading
  );
  const googleLoginAction = useSelector(
    (state) => state.authentication.googleLoginAction
  );

  const googleLogin = async () => {
    try {
      dispatch(performGoogleLogin());
    } catch (e) {
      sendErrorNotification("Kunne ikke logge inn med Google.");
      dispatch(resetGoogleLogin());
    }
  };

  const clickLogin = async (e) => {
    try {
      if (email && password) {
        dispatch(performRegularLogin({ email: email, password: password }));
      } else {
        sendErrorNotification("Du må fylle inn begge felter.");
      }
    } catch (e) {
      setPassword("");
      sendErrorNotification("Feil passord, vennligst prøv igjen.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      !regularLoginLoading &&
      !googleLoginLoading &&
      auth &&
      auth.currentUser &&
      auth.currentUser.uid
    ) {
      history.push("/dashboard/oversikt");
    }
  }, user);

  useEffect(() => {
    if (!regularLoginLoading && regularLoginError) {
      sendErrorNotification(regularLoginError);
      setPassword("");
      dispatch(resetRegularLogin());
    }

    if (
      !regularLoginLoading &&
      regularLoginStatus &&
      regularLoginStatus === "success"
    ) {
      history.push("/dashboard/oversikt");
      dispatch(resetRegularLogin());
    }
  }, [regularLoginLoading, regularLoginError, regularLoginStatus]);

  useEffect(() => {
    if (
      !googleLoginLoading &&
      googleLoginStatus &&
      googleLoginStatus === "success"
    ) {
      if (googleLoginAction && googleLoginAction === "register") {
        history.push("/registrer");
      } else {
        history.push("/dashboard/oversikt");
      }
    }
  }, [googleLoginLoading, googleLoginError, googleLoginStatus]);

  return (
    <section className="login-page-section">
      <div className="inner-login-page-container">
        <div className="full-content-container">
          <div className="login-display-container">
            <div className="login-box-container">
              <div className="inner-login-box-container">
                <Link to="/">
                  <img
                    alt="Leadfind logo"
                    className="login-logo"
                    src={lightLogo}
                  />
                </Link>
                <h3 className="login-title">Logg inn på kontoen din</h3>
                <div className="login-oidc-container">
                  <button
                    onClick={() => googleLogin()}
                    className="google-login-button"
                  >
                    <GoogleIcon className="google-icon" /> Logg inn med Google
                  </button>
                </div>
                <div className="login-display-container">
                  <div class="input-group">
                    <Label version={1} weight="bold">
                      E-post
                    </Label>
                    <Input
                      onKeyDown={(e) =>
                        e.key === "Enter" ? clickLogin() : null
                      }
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      placeholder="E-post"
                      type="email"
                    />
                  </div>
                  <div class="input-group">
                    <Label version={1} weight="bold">
                      Passord
                    </Label>
                    <Input
                      onKeyDown={(e) =>
                        e.key === "Enter" ? clickLogin() : null
                      }
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      type="password"
                      placeholder="Passord"
                    />
                    <Link to="/glemt-passord">Glemt passord?</Link>
                  </div>
                  <div className="button-container">
                    <button
                      onClick={() => clickLogin()}
                      className="login-button"
                    >
                      {regularLoginLoading ? (
                        <i className="fas fa-circle-notch fa-spin"></i>
                      ) : null}{" "}
                      {regularLoginLoading ? "Logger inn.." : "Logg inn"}
                    </button>
                  </div>
                  <div className="sign-up-container">
                    <p className="signup-label">
                      Har du ikke en konto?{" "}
                      <Link to="/registrer">Registrer deg gratis</Link>.
                    </p>
                  </div>
                  <div className="oidc-container">
                    <button>Logg inn med Google</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="links-container">
              <Link to="/">Leadfind.no</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/personvern">Personvern</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/cookies">Cookies</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/vilkår">Vilkår</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
